import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@vfit/shared/atoms";
import { Background, CloseButton } from "./modal.style";
var Modal = function(param) {
    var children = param.children, show = param.show, onCloseModal = param.onCloseModal;
    var onClickHandler = function() {
        onCloseModal === null || onCloseModal === void 0 ? void 0 : onCloseModal();
    };
    if (!show) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Background, {
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(CloseButton, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        size: "responsive",
                        className: "button-close",
                        type: "button",
                        variant: "secondary",
                        model: "circle",
                        svg: "closeLs",
                        onClick: onClickHandler,
                        tabIndex: 0
                    })
                }),
                children
            ]
        })
    });
};
export default Modal;
